import { Card, Flex, Tooltip, Typography } from "antd";
import { AudioSample } from "../../components/AudioSample";
import { DeleteButton } from "@refinedev/antd";
import { errorNotificationWithEntityIdsHandler } from "pages/onboarding/helpers/";
import { FileOrPath } from "./BrandKitAssetPreview";

export type MusicAsset = {
  name: string;
  asset_id?: string;
} & FileOrPath & { uid?: string };

export const MusicPreview = ({
  width = 200,
  asset,
  showDeleteButton,
  brandKitId,
  organizationId,
  onDeleteSuccess,
  volume,
}: {
  width?: number;
  asset: MusicAsset;
  showDeleteButton: boolean;
  brandKitId: string;
  organizationId: string;
  onDeleteSuccess?: () => void;
  volume?: number;
}) => {
  return (
    <Card size="small" style={{ minWidth: width }}>
      <Flex gap={10} justify="space-between" align="center">
        <AudioSample
          canDelete={false}
          audio={asset?.file ?? asset.path}
          volume={volume}
        >
          <Tooltip title={asset.name} placement="bottom" arrow={false}>
            <Typography.Text ellipsis style={{ flex: "0 1 105px", width: 105 }}>
              {asset.name}
            </Typography.Text>
          </Tooltip>
        </AudioSample>
        {showDeleteButton && (
          <DeleteButton
            accessControl={{ enabled: false }}
            hideText
            recordItemId={asset.asset_id}
            resource={`media/${organizationId}/brand_kits/${brandKitId}/assets`}
            onSuccess={onDeleteSuccess}
            errorNotification={(error) => {
              const result = errorNotificationWithEntityIdsHandler(
                error,
                "project_ids"
              );
              return result;
            }}
          />
        )}
      </Flex>
    </Card>
  );
};
